var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            { attrs: { md3: "" } },
            [
              _c("v-select", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  items: _vm.tiposZona,
                  label: "Tipo de Zona",
                  icon: "fas fa-angle-down",
                  "item-text": "descripcion",
                  "item-value": "id",
                  "error-messages": _vm.errors.collect("informeRequerido"),
                  "data-vv-name": "informeRequerido",
                  required: "",
                  disabled: _vm.accion === 3
                },
                on: {
                  change: function($event) {
                    return _vm.setTipoZona()
                  }
                },
                model: {
                  value: _vm.formFields.tipoZonaSeleccionado.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.tipoZonaSeleccionado, "value", $$v)
                  },
                  expression: "formFields.tipoZonaSeleccionado.value"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("v-divider"),
      _c("br"),
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            { attrs: { md6: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  "prepend-icon": "lock_open",
                  label: "Buscar zonas...",
                  "append-icon": "search",
                  disabled: _vm.accion === 3
                },
                on: { input: _vm.onFilterTextBoxChanged },
                model: {
                  value: _vm.buscarAccion,
                  callback: function($$v) {
                    _vm.buscarAccion = $$v
                  },
                  expression: "buscarAccion"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { align: "left" } },
        [
          _c(
            "v-flex",
            [
              _c("MantenedorGrid", {
                attrs: { "grid-options": _vm.gridOptionsActividad }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }